import { render } from "./ProgramChairDashboard.vue?vue&type=template&id=5c1f7e3e&scoped=true"
import script from "./ProgramChairDashboard.vue?vue&type=script&lang=js"
export * from "./ProgramChairDashboard.vue?vue&type=script&lang=js"

import "./ProgramChairDashboard.vue?vue&type=style&index=0&id=5c1f7e3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1f7e3e"]])

export default __exports__